export const backendAPI = "https://baddybuzz.herokuapp.com";

//dev api
// export const backendAPI = "http://localhost:5000";

export const CLOUDINARY_BASE_URL = process.env.REACT_APP_CLOUDINARY_BASE_URL;

export const CLOUDINARY_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;
